/* eslint-disable no-template-curly-in-string */
import React from "react"

import globalStyles from "../../../../App.module.scss"
import {Prism as SyntaxHighlighter} from "react-syntax-highlighter"
import {dracula} from "react-syntax-highlighter/dist/cjs/styles/prism"

let example = `#!/usr/bin/env bash

# Fail fast if a required variable is missing
: "$\{API_KEY:?API_KEY must be set}"

# Fall back to a default without mutating the variable
port="$\{PORT:-8080}"

# Only assign once, then remember it
: "$\{RETRIES:=3}"

# Use an alternate value only when the variable IS set
echo "debug mode$\{DEBUG:+ (verbose)}"`

export default function ParameterExpansion() {
    return (
        <div className={globalStyles.article}>
            <h1>Parameter expansion defaults</h1>
            <p>Bash has built-in operators for handling unset or empty variables without an explicit
                <code> if</code> check.</p>

            <div className={globalStyles.styledTable}>
                <table style={{minWidth: '550px'}}>
                    <thead>
                    <tr>
                        <th>Syntax</th>
                        <th>Behavior</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><code>{"${var:-default}"}</code></td>
                        <td>Expands to <code>default</code> if <code>var</code> is unset or empty.
                            <code> var</code> itself is left unchanged.</td>
                    </tr>
                    <tr>
                        <td><code>{"${var-default}"}</code></td>
                        <td>Same, but only if <code>var</code> is unset (an empty string is left as-is)</td>
                    </tr>
                    <tr>
                        <td><code>{"${var:=default}"}</code></td>
                        <td>Same as <code>:-</code> but also assigns <code>default</code> to <code>var</code></td>
                    </tr>
                    <tr>
                        <td><code>{"${var:?message}"}</code></td>
                        <td>Print <code>message</code> to stderr and exit if <code>var</code> is unset or empty</td>
                    </tr>
                    <tr>
                        <td><code>{"${var:+alt}"}</code></td>
                        <td>Expands to <code>alt</code> only if <code>var</code> IS set and non-empty</td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <h3>Example</h3>
            <SyntaxHighlighter
                children={example}
                style={dracula}
                PreTag="div"
                language={'bash'}
            />
            <p>The <code>: "..."</code> pattern (the <code>:</code> no-op builtin) is a common idiom for
                triggering <code>:?</code>/<code>:=</code> for their side effects without running a real
                command.</p>
        </div>
    )
}
